<template>
  <div id="app" class="m-common-page">
    <Header></Header>
    <router-view />
    <Footer></Footer>
    <!--<a-back-top :visibilityHeight="100">-->
    <!--<div class="m-gotop">-->
    <!--<img :src="'./images/gotop.png'" alt="" />-->
    <!--</div>-->
    <!--<div class="ant-back-top-inner">返回顶部</div>-->
    <!--</a-back-top>-->
  </div>
</template>
<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer";
import account from "./services/account";
import { ck } from "fire-wind-water/cookie";
import { apiUrl } from "./services/account";
import { URLS } from "fire-wind-water/url";

ck.json = true;
const tenantId = URLS.getURL("tenantId");
const isPreview = URLS.getURL("isPreview");

export default {
  name: "App",
  data() {
    return {
      setTitle: "",
      siteMenu: []
    };
  },
  components: {
    Header,
    Footer
  },
  created() {
    if (!tenantId) {
      this.$message.error("缺少租户Id");
    }
    window.$swxsdk.initWxSdk({ tenantId }, apiUrl);
    // window.$s_temp.initPiwikPostUrl({
    //   apiUrl: apiUrl,
    //   matomoUrl: URL.template.matomoUrl
    // });
    // window.$s_temp.initPiwik();
    this.getStatus();
    this.getSetting();
  },
  methods: {
    getStatus() {
      account.aggregationConfigGet({ tenantId: tenantId }).then(data => {
        if (data.result == 0) {
          if (data.content.status != 1 && isPreview != 1) {
            window.location.href = "//s2-tenant.smarket.net.cn/404";
          }
        } else {
          this.$message.error(data.desc);
        }
      });
    },
    getSetting() {
      var self = this;
      account.getTempSetting({ tenantId: tenantId }).then(data => {
        if (data.result == 0) {
          this.siteMenu = data.content.configInfo.site_menu || [];
          if (data.content.configInfo.site_title) {
            self.setTitle = data.content.configInfo.site_title;
            this.isTitle();
          }

          console.log(data.content.configInfo);
          this.$store.dispatch("actionsTempConfig", data.content.configInfo);
          window.$swxsdk.on("sharer", {
            title: data.content.configInfo.site_title,
            desc: data.content.configInfo.share_description,
            link: window.location.href,
            imgUrl: "https:" + data.content.configInfo.share_image
          });
          window.$swxsdk.on("sharer_friends", {
            title: data.content.configInfo.site_title,
            desc: data.content.configInfo.share_description,
            link: window.location.href,
            imgUrl: "https:" + data.content.configInfo.share_image
          });

          if (data.content.configInfo.loadingUrl) {
            ck.cookie(
              "smarket_webinar_jh_" + tenantId,
              data.content.configInfo.loadingUrl,
              { path: "/", expires: 30 }
            );
          } else {
            ck.removeCookie("smarket_webinar_jh_" + tenantId);
          }
        } else {
          this.$message.error(data.desc);
        }
        var link = document.getElementById("icon-favicon");
        var url = data.content.configInfo.faviconUrl;
        if (url.indexOf("https") < 0) {
          url = url.replace("http", "https");
        }
        if (link) {
          link.href = url || "//cdn.smarket.net.cn/images/logo.ico";
        }
        setTimeout(() => {
          var page = document.querySelector(".m-page-loading");
          if (page) {
            page.style.display = "none";
          }
        }, 300);
        window.$swxsdk.on("sharer", {
          title: data.content.configInfo.site_title,
          desc: data.content.configInfo.share_description,
          link: window.location.href,
          imgUrl: "https:" + data.content.configInfo.share_image
        });
        window.$swxsdk.on("sharer_friends", {
          title: data.content.configInfo.site_title,
          desc: data.content.configInfo.share_description,
          link: window.location.href,
          imgUrl: "https:" + data.content.configInfo.share_image
        });
      });
    },
    isTitle() {
      const tenantTitle = {
        949: {
          Index: "赛诺贝斯视频聚合站",
          Category: "视频分类",
          Live: "直播预告",
          Demand: "往期回放",
          Search: "搜索结果页"
        },
        // 快速响应群李婷反馈， 霍尼韦尔租户需要去掉这里，走标准逻辑
        // 1355: {
        //   Index: "培训视频",
        //   Category: "视频分类",
        //   Live: "直播列表",
        //   Demand: "点播列表",
        //   Search: "搜索结果页"
        // },
        all: {
          Index: this.setTitle || "视频聚合站",
          Category: this.siteMenu[1] || "视频分类",
          Live: this.siteMenu[2] || "直播列表",
          Demand: this.siteMenu[3] || "点播列表",
          Search: "搜索结果页"
        }
      };
      const t = tenantTitle[tenantId] || tenantTitle.all;
      const titles = {
        Index: t.Index,
        Category: t.Category + "_" + t.Index,
        Live: t.Live + "_" + t.Index,
        Demand: t.Demand + "_" + t.Index,
        Search: t.Search + "_" + t.Index
      };
      document.title = titles[this.$route.name];
    }
  },
  watch: {
    $route: {
      handler: function() {
        this.isTitle();
      },
      // 深度观察监听
      deep: true
    }
  }
};
</script>
<style lang="scss"></style>
